import { takeEvery, put } from 'redux-saga/effects'
import { change } from 'redux-form/immutable'
import { IDENTITY_ONBOARDING_SET_EVENING_NOTIFICATION_HOUR_LATER } from '../actionTypes'
import { START_JOURNEY_FORM_NAME as FORM_NAME } from 'app/constants/startJourney'
import { subscribeToProTrack, updateSubscribeToProTrack } from '../actions'
import { showSuccess } from 'store/entities/toastr/utils'
import { SUBSCRIBED_TO_PROTRACK } from 'app/constants/toastrMessages'
import { modal } from 'store/entities/modal/actions'
import OnBoardingBriefQuiz from 'app/domains/routes/OnBoarding/OnBoardingBriefQuiz'

export default function* protrackSubscriptionSaga() {
  yield takeEvery(subscribeToProTrack.success.toString(), handleProtrackSubscriptionPostSuccess)
  yield takeEvery(IDENTITY_ONBOARDING_SET_EVENING_NOTIFICATION_HOUR_LATER, setEveningNotification)
  yield takeEvery(updateSubscribeToProTrack.success.toString(), handleProtrackSubscriptionPostSuccess)
}

export function* setEveningNotification(action) {
  yield put(change(FORM_NAME, 'committedNotificationTime', action.payload.time))
}

export function* handleProtrackSubscriptionPostSuccess({ payload: { data } }) {
  showSuccess({ content: SUBSCRIBED_TO_PROTRACK(`${data.proTrack.proTrackName} (${data.proTrack.name})`) })
  yield put(modal.show(OnBoardingBriefQuiz, { size: 'md', important: true }))
}
